import React, { useState, useCallback, useEffect } from 'react';
import { Box, Card, CardActions, CardContent, IconButton, Typography } from '@mui/material';
import { Button, FormGroup, FormControlLabel, InputLabel, Checkbox } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux"
import { imageURL } from "../utils/config";
import { AcceptableUseAPI } from "../services/AcceptableUseAPI"
import { Link } from "react-router-dom";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PrintIcon from '@mui/icons-material/Print';
import Swal from "sweetalert2";
import "./pdpa.css"

const AcceptableUse = ({ closeNav, isMobile }) => {
    const dispatch = useDispatch()
    const [check, setCheck] = useState(false)
    const { user: { userData } } = useSelector(state => state)

    useEffect(() => {
        if (userData instanceof Object && userData.acceptable_use) {
            setCheck(true)
        }
    }, [userData])
    const handleSubmit = useCallback(async () => {
        try {
            if (userData instanceof Object && userData.acceptable_use) throw { message: "คุณเคยทำ Acceptable Use Policy ไปแล้ว" }
            const { status, message } = await AcceptableUseAPI.submitAcceptable()
            if (status == 502) throw { message }
            localStorage.setItem("Token", message)
            Swal.fire({
                icon: 'success',
                confirmButtonColor: "#6ab23a",
                text: `ยอมรับและรับทราบนโยบายเรียบร้อย`,
                timer: 5000
            }).then(() => {
                dispatch({ type: "USER_UPDATE", payload: { acceptable_use: true } })
            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                width: '28rem',
                timer: 3000
            });
        }
    }, [userData])

    const clearText = useCallback((text) => {
        let newText = text.replace(/\D/g, "")
        return newText
    }, [userData])

    return (
        <>
            <div className='container h-100vh' style={{ marginTop: '10%', display: closeNav ? 'flex' : isMobile ? 'none' : 'flex', marginTop: !isMobile ? 0 : '10%', justifyContent: 'flex-start', padding: '0' }}>
                <Card
                    sx={{
                        overflowY: 'auto',
                        minWidth: 275,
                        marginLeft: { xs: 0, sm: '5%' },
                        marginRight: { xs: 0, sm: '5%' },

                    }} style={{ boxShadow: 'none' }} >
                    <CardActions
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'row', sm: 'row' },
                            width: '-webkit-fill-available',
                            justifyContent: 'center',

                        }}
                        style={{ opacity: '100%', borderBottomStyle: 'solid', borderBottomColor: '#5BB846', }}>
                        <Box style={{ border: '1px solid', borderBottomColor: 'black', height: '-webkit-fill-available', alignContent: 'center' }}>
                            <img src={`${imageURL}/icons/icon1.png`} alt="" style={{ width: '10vw' }} />
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'column' },
                            height: '-webkit-fill-available',
                            justifyContent: 'space-between',


                        }} style={{ marginLeft: 0, border: '2px', border: '1px solid', borderBottomColor: 'black', }}>
                            <Typography variant="body2" style={{ padding: '4px', textWrap: 'pretty', borderBottom: '1px solid', borderBottomColor: 'black', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', height: '-webkit-fill-available' }}>
                                ชื่อเอกสาร
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', textWrap: 'pretty', borderBottom: '1px solid', borderBottomColor: 'black', fontSize: isMobile ? '10px' : '12px', textTransform: 'uppercase', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', height: '-webkit-fill-available' }}>
                                ระดับชั้นความลับ
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', textWrap: 'pretty', textTransform: 'uppercase', fontSize: isMobile ? '10px' : '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', height: '-webkit-fill-available' }}>
                                วันที่มีผลบังคับใช้
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'column' },
                            height: '-webkit-fill-available',
                            justifyContent: 'space-between',

                        }} style={{ marginLeft: 0, border: '2px', border: '1px solid', borderBottomColor: 'black', }}>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', textWrap: 'pretty', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                ใบลงนามรับทราบและถือปฏิบัติตามนโยบายการใช้ระบบเทคโนโลยีสารสนเทศเพื่อความมั่นคงปลอดภัยสำหรับผู้ใช้งาน (Acceptable Use Policy)
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '10px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                ใช้ภายใน
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', textTransform: 'uppercase', fontSize: isMobile ? '10px' : '12px', fontWeight: 700, textAlign: 'left', width: '-webkit-fill-available', height: '-webkit-fill-available' }}>
                                30 มีนาคม 2569
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'column' },
                            height: '-webkit-fill-available',
                            justifyContent: 'space-between',

                        }} style={{ marginLeft: 0, border: '2px', border: '1px solid', borderBottomColor: 'black', }}>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                รหัสเอกสาร
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                เวอร์ชัน
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                เวอร์ชัน
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'column' },
                            height: '-webkit-fill-available',
                            justifyContent: 'space-between',

                        }} style={{ marginLeft: 0, border: '2px', border: '1px solid', borderBottomColor: 'black', }}>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                FM-IT-013
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', borderBottom: '1px solid', borderBottomColor: 'black', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                1.0
                            </Typography>
                            <Typography variant="body2" style={{ padding: '4px', textTransform: 'uppercase', fontSize: isMobile ? '9px' : '12px', fontWeight: 700, textAlign: 'left', height: '-webkit-fill-available', width: '-webkit-fill-available' }}>
                                1 / 1
                            </Typography>
                        </Box>

                    </CardActions>
                    <CardContent style={{ display: 'flex', flexDirection: 'column', gap: '4px', textWrap: 'pretty' }}>
                        <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '8px', textAlign: 'center' }}>
                            ใบลงนามรับทราบและถือปฏิบัติตาม
                            <br />
                            นโยบายการใช้ระบบเทคโนโลยีสารสนเทศ
                            <br />
                            เพื่อความมั่นคงปลอดภัยสำหรับผู้ใช้งาน (Acceptable Use Policy)
                        </Typography>
                        <Typography variant="body2" style={{ textIndent: '3.125rem', textAlign: 'left' }}>
                            บริษัท คอมเซเว่น จำกัด (มหาชน) (“บริษัท”) ให้ความสำคัญและตระหนักถึงความสำคัญของการบริหารจัดการความมั่นคงปลอดภัยสารสนเทศที่มีประสิทธิภาพและเป็นไปตามมาตรฐานสากล ISO/IEC 27001:2022 โดยยึดถือหลักการสำคัญ 3 ประการดังนี้
                        </Typography>
                         <br />
                        <Typography variant="body2" style={{  textAlign: 'left' }}>
                             &nbsp;&emsp;&emsp;&emsp;(1) การรักษาความลับ (Confidentiality): ปกป้องระบบและข้อมูลจากการเข้าถึงโดยไม่ได้รับอนุญาต<br/>
                             &nbsp;&emsp;&emsp;&emsp;(2) ความถูกต้องครบถ้วน (Integrity): ข้อมูลและระบบต้องมีความถูกต้อง น่าเชื่อถือ และไม่ถูกแก้ไขโดยมิชอบ<br/>
                             &nbsp;&emsp;&emsp;&emsp;(3) ความพร้อมใช้งาน (Availability): ระบบเทคโนโลยีสารสนเทศต้องพร้อมรองรับการใช้งานได้อย่างต่อเนื่อง<br/>
                        </Typography>
                         <br />
                        <Typography variant="body2" style={{ textIndent: '3.125rem', textAlign: 'left' }}>
                            เพื่อให้การใช้งานระบบเทคโนโลยีสารสนเทศของบริษัทเป็นไปอย่างเหมาะสม ปลอดภัย และสอดคล้องกับกฎหมายที่เกี่ยวข้อง บริษัทจึงได้กำหนด “นโยบายการใช้งานระบบเทคโนโลยีสารสนเทศ (Acceptable Use Policy)”<br/>เพื่อให้พนักงานและผู้ปฏิบัติงานทุกคนรับทราบและใช้เป็นแนวทางในการป้องกันความเสี่ยงที่อาจเกิดจากการใช้งานที่ไม่ถูกต้อง
                        </Typography>
                         <br />
                        <Typography variant="body2" style={{ textIndent: '3.125rem', textAlign: 'left', 
                            // fontWeight: 'bold' 
                            }}>
                            จึงขอให้พนักงานทุกท่านศึกษารายละเอียดของนโยบาย และลงนามรับทราบเพื่อถือปฏิบัติอย่างเคร่งครัดตามเอกสารฉบับนี้
                        </Typography>

                    </CardContent>
                    <CardActions style={{ flexDirection: 'column', alignItems: 'start', opacity: '50%' }}>
                        <Typography variant="body2" style={{ fontWeight: 700, textTransform: 'uppercase', textAlign: 'right', width: '-webkit-fill-available', borderBottomStyle: 'solid', borderBottomColor: '#5BB846' }}>

                        </Typography>

                    </CardActions>
                    <CardActions style={{ flexDirection: 'column', alignItems: 'center', margin: 'auto' }}>
                        <FormGroup className={`group-mt_1`} style={{ marginTop: 5 }}>
                            <InputLabel style={{ textAlign: 'center' }}>
                                <strong>{userData.fullname}</strong>
                            </InputLabel>
                            <InputLabel style={{ textAlign: 'center', marginTop: 5, marginBottom: 10 }}>
                                <strong>( {userData.PositionName} )</strong>
                            </InputLabel>
                            <CardActions style={{ flexDirection: 'row', alignItems: 'center', margin: 'auto' }}>
                                <FormControlLabel control={<Checkbox disabled={userData?.acceptable_use} checked={check} onClick={() => { setCheck((old) => !old) }} />} label="ยอมรับและรับทราบนโยบาย" />
                                <a href="https://cdn.com7tracking.com/PC-IT-002%20%E0%B8%99%E0%B9%82%E0%B8%A2%E0%B8%9A%E0%B8%B2%E0%B8%A2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A%E0%B9%80%E0%B8%97%E0%B8%84%E0%B9%82%E0%B8%99%E0%B9%82%E0%B8%A5%E0%B8%A2%E0%B8%B5%E0%B8%AA%E0%B8%B2%E0%B8%A3%E0%B8%AA%E0%B8%99%E0%B9%80%E0%B8%97%E0%B8%A8.pdf" target="_blank" >
                                    อ่านเพิ่มเติม
                                </a>
                            </CardActions>

                        </FormGroup>
                        <Button
                            onClick={handleSubmit}
                            disabled={!check || userData?.acceptable_use}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: (!check || userData?.acceptable_use) ? "lightgray" : "#6ab23a", color: 'white', cursor: 'pointer', marginTop: 5
                            }}
                        >
                            บันทึก
                        </Button>
                    </CardActions>
                </Card>
            </div></>)
}

export default AcceptableUse